<template>
    <div class="over" style="width:1200px;">
        <div class="tpbj" v-for="(item,index) in list" :key="index">
            <router-link :to="{path:'/tj_detail', query:{id:item.id}}" target="_blank" style="padding:25px 10px;overflow: hidden;display: block;text-align:center;">
                <img :src="item.piclink" width="350" height="350" alt="">
                <div style="background:#ffffff;">
                    <p style="padding: 14px 18px;font-size: 18px;line-height: 30px;overflow: hidden;">{{item.title | ellipsis}}</p>
                    <p>
                        <span style="float:left;margin-right:10px;font-size:14px;">已售{{$fnc.toFixedZ(item.sold,2)}}%</span>
                        <span><limit-percent :num="Number(item.sold)"></limit-percent></span>
                    </p>
                    <p style="line-height:25px;margin-top:20px;">
                        <span style="font-size:26px;color:#f00180;font-weight:bold;float:left;">￥{{item.limited_price}}</span>
                        <span style="float:left;text-decoration:line-through">￥{{item.price}}</span>
                        <span style="background:#f00180;font-size:16px;color:#fff;padding:5px 10px;border-radius:10px;float:right;">马上抢</span>
                    </p>
                    
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
import Limit_percent from "./limit_percent"
export default {
    components:{
        'limit-percent' : Limit_percent
    },
    filters: {//限制文本显示字数,超出部分用...代替
        ellipsis (value) {
            if (!value) return ''
            if (value.length > 10) {
                return value.slice(0,15) + '...'//0:下标,从第一个字开始显示,50:显示字数,多余用...代替
            }
            return value
        }
    },
    data() {
        return {
            percent: 50,
            calleft: 0,
            list:[],
        };
    },
    mounted(){
        this.getEveryday();
    },
    methods:{
        getEveryday() {
            // this.$api.getShop.getXianshiqianggou({}).then(res => {
            //     if (res.code == 200) {
            //         this.end_time = res.result[0].end_time;
            //         var id = res.result[0].id;
            //         var params = {};
            //         params.id = id || "";
            //         this.$api.getShop.getXsqgList(params).then(ress => {
            //             if (ress.code == 200) {
            //                 this.list = ress.result;
            //             }
            //         });
            //     }
            // });
            this.$api.getShop.getEverydayList({}).then(ress => {
                if (ress.code == 200) {
                    this.list = ress.result;
                }
            });
        },
    }
}
</script>

<style scoped>
.tpbj{
	background: url(../../assets/picture/index/tpbj.png) no-repeat;
	width: 385px;
	height: 534px;
	/* position: absolute; */
	float: left;
	margin-right: 15px;
	margin-bottom: 25px;
}
/* .tpbj a:hover{
	border:1px solid #dedede;
	color:#f00180;
	border-radius: 10px;
} */
.btn-buy{
	background: url(../../assets/picture/index/btn.png) no-repeat;
	width: 165px;
	height: 36px;
	line-height: 36px;
	color: #ffffff;
	text-align: center;
	margin-left: 22%;
	font-size: 18px;
}
/* a:hover{
	text-decoration:none;
	color: #f00180;
} */
</style>


// WEBPACK FOOTER //
// src/components/pintuan/tejia.vue